// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"SearchBar-styles-suggestions-bb77630c"};